import React from 'react'
import { Route, Routes } from 'react-router'

import { AiSettingsPage } from '../pages/AiSettingsPage'
import { BasicOutputGenerationPage } from '../pages/BasicOutputGenerationPage'
import { BrandAccountAllowedDomainListPage } from '../pages/BrandAccountAllowedDomainListPage'
import { BrandAccountPage } from '../pages/BrandAccountPage'
import { BrandAccountUserListPage } from '../pages/BrandAccountUserListPage'
import { BrandGroupListPage } from '../pages/BrandGroupListPage'
import { BrandListPage } from '../pages/BrandListPage'
import { CreateSurveyPage } from '../pages/CreateSurveyPage'
import { CustomerAnalysisPage } from '../pages/CustomerAnalysisPage'
import { CustomerAttributeAnalysisPage } from '../pages/CustomerAttributeAnalysisPage'
import { CustomerAttributeListPage } from '../pages/CustomerAttributeListPage'
import { CustomerAttributeSettingsPage } from '../pages/CustomerAttributeSettingsPage'
import { CustomizedAnalysisPage } from '../pages/CustomizedAnalysisPage'
import { DataSettingsPage } from '../pages/DataSettingsPage'
import { DocumentImageArchiveListPage } from '../pages/DocumentImageArchiveListPage'
import { DocumentImageListPage } from '../pages/DocumentImageListPage'
import { DocumentQaPage } from '../pages/DocumentQaPage'
import { DocumentReportArchiveListPage } from '../pages/DocumentReportArchiveListPage'
import { DocumentReportEditPage } from '../pages/DocumentReportEditPage'
import { DocumentReportListPage } from '../pages/DocumentReportListPage'
import { NinesegsAnalyzerTopPage } from '../pages/NinesegsAnalyzerTopPage'
import { OverlapAnalysisPage } from '../pages/OverlapAnalysisPage'
import { RestoreSurveyFilterPage } from '../pages/RestoreSurveyFilterPage'
import { RestoreSurveyGroupFilterPage } from '../pages/RestoreSurveyGroupFilterPage'
import { SegmentDefinitionsPage } from '../pages/SegmentDefinitionsPage'
import { StandardAnalysisPage } from '../pages/StandardAnalysisPage'
import { StrategyMemoArchiveListPage } from '../pages/StrategyMemoArchiveListPage'
import { StrategyMemoEditPage } from '../pages/StrategyMemoEditPage'
import { StrategyMemoListPage } from '../pages/StrategyMemoListPage'
import { SurveyPage } from '../pages/SurveyPage'
import { SurveySettingsPage } from '../pages/SurveySettingsPage'
import { TimeSeriesAnalysisPage } from '../pages/TimeSeriesAnalysisPage'
import { TimeSeriesSettingsPage } from '../pages/TimeSeriesSettingsPage'
import { WhoAndWhatAnalysisPage } from '../pages/WhoAndWhatAnalysisPage'

import { type PathKey, pathKeys, resolve } from './paths'

export const pathPageMap: Record<PathKey, React.ComponentType> = {
  top: NinesegsAnalyzerTopPage,
  aiSettings: AiSettingsPage,
  basicOutputGeneration: BasicOutputGenerationPage,
  brandAccount: BrandAccountPage,
  brandAccountAllowedDomainList: BrandAccountAllowedDomainListPage,
  brandAccountUserList: BrandAccountUserListPage,
  brandGroupList: BrandGroupListPage,
  brandList: BrandListPage,
  createSurvey: CreateSurveyPage,
  customerAnalysis: CustomerAnalysisPage,
  customerAttributeAnalysis: CustomerAttributeAnalysisPage,
  customerAttributeList: CustomerAttributeListPage,
  customerAttributeSettings: CustomerAttributeSettingsPage,
  customizedAnalysis: CustomizedAnalysisPage,
  dataSettings: DataSettingsPage,
  documentImageArchiveList: DocumentImageArchiveListPage,
  documentImageList: DocumentImageListPage,
  documentQa: DocumentQaPage,
  documentReportArchiveList: DocumentReportArchiveListPage,
  documentReportEdit: DocumentReportEditPage,
  documentReportList: DocumentReportListPage,
  overlapAnalysis: OverlapAnalysisPage,
  restoreSurveyFilter: RestoreSurveyFilterPage,
  restoreSurveyGroupFilter: RestoreSurveyGroupFilterPage,
  segmentDefinitions: SegmentDefinitionsPage,
  standardAnalysis: StandardAnalysisPage,
  strategyMemoArchiveList: StrategyMemoArchiveListPage,
  strategyMemoEdit: StrategyMemoEditPage,
  strategyMemoList: StrategyMemoListPage,
  survey: SurveyPage,
  surveySettings: SurveySettingsPage,
  timeSeriesAnalysis: TimeSeriesAnalysisPage,
  timeSeriesSettings: TimeSeriesSettingsPage,
  whoAndWhatAnalysis: WhoAndWhatAnalysisPage,
}

export const Root = () => (
  <Routes>
    {pathKeys.map((pathKey) => {
      const Page = pathPageMap[pathKey]

      return <Route key={pathKey} element={<Page />} path={resolve(pathKey)} />
    })}
  </Routes>
)
